import React from 'react';
import { Box, Typography, Paper, Grid, Card, CardContent, Button } from '@mui/material';
import MeetingIcon from '@mui/icons-material/MeetingRoom';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import WarningIcon from '@mui/icons-material/Warning';
import AssignmentIcon from '@mui/icons-material/Assignment';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import FolderIcon from '@mui/icons-material/Folder';

export default function QualidadePage() {
  const acoesRapidas = [
    { icon: <MeetingIcon />, label: 'Reunião', color: '#1976d2' },
    { icon: <TrendingUpIcon />, label: 'Vlr Indicador', color: '#2e7d32' },
    { icon: <WarningIcon />, label: 'Ocorrência', color: '#d32f2f' },
    { icon: <AssignmentIcon />, label: 'Gol', color: '#ed6c02' },
    { icon: <RequestQuoteIcon />, label: 'Solicitação', color: '#9c27b0' },
    { icon: <FolderIcon />, label: 'Recursos', color: '#0288d1' },
  ];

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" component="h1" gutterBottom fontWeight={700} sx={{ mb: 4 }}>
        Dashboard - Sistema de Qualidade
      </Typography>

      {/* Botões de Ação Rápida */}
      <Paper 
        elevation={3}
        sx={{ 
          p: 3, 
          mb: 4,
          background: 'linear-gradient(135deg, rgba(255,255,255,0.95) 0%, rgba(240,248,255,0.9) 100%)',
          borderRadius: 3
        }}
      >
        <Typography variant="h6" fontWeight={600} sx={{ mb: 3 }}>
          Ações Rápidas
        </Typography>
        <Grid container spacing={2}>
          {acoesRapidas.map((acao, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Button
                fullWidth
                variant="outlined"
                startIcon={acao.icon}
                sx={{
                  py: 2,
                  borderColor: acao.color,
                  color: acao.color,
                  '&:hover': {
                    borderColor: acao.color,
                    backgroundColor: `${acao.color}10`
                  }
                }}
              >
                {acao.label}
              </Button>
            </Grid>
          ))}
        </Grid>
      </Paper>

      {/* Cards de Resumo */}
      <Grid container spacing={3}>
        <Grid item xs={12} md={4}>
          <Card sx={{ 
            background: 'linear-gradient(135deg, rgba(255,255,255,0.95) 0%, rgba(240,248,255,0.9) 100%)',
            borderRadius: 3
          }}>
            <CardContent>
              <Typography variant="h3" fontWeight={700} color="primary">
                9
              </Typography>
              <Typography variant="h6" color="text.secondary">
                Reuniões
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={4}>
          <Card sx={{ 
            background: 'linear-gradient(135deg, rgba(255,255,255,0.95) 0%, rgba(240,248,255,0.9) 100%)',
            borderRadius: 3
          }}>
            <CardContent>
              <Typography variant="h3" fontWeight={700} color="success.main">
                15
              </Typography>
              <Typography variant="h6" color="text.secondary">
                Indicadores
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={4}>
          <Card sx={{ 
            background: 'linear-gradient(135deg, rgba(255,255,255,0.95) 0%, rgba(240,248,255,0.9) 100%)',
            borderRadius: 3
          }}>
            <CardContent>
              <Typography variant="h3" fontWeight={700} color="warning.main">
                5
              </Typography>
              <Typography variant="h6" color="text.secondary">
                Ocorrências Pendentes
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
}
